import Vue from 'vue';
import store from '@/store/';
import jQuery from 'jquery';

Vue.mixin({
     computed: {
          brand: () => {
               const brand = store.getters['Brand/brand'];
               jQuery('body').addClass('brand-' + brand);

               return brand;
          },
     },
});
